export const ROUTES = {
  home: '/',
  login: '/login',
  onboarding: '/onboarding',
  app: {
    root: '/app',
    dashboard: '/app/dashboard',
    insights: '/app/insights',
    trips: '/app/trips',
    trip: (id: string) => `/app/trips/${id}`,
    transactions: '/app/transactions',
    subscriptions: '/app/subscriptions',
    tags: '/app/tags',
    accounts: '/app/accounts',
    reviews: '/app/reviews',
    settings: '/app/settings',
  },
} as const;
